import { api } from "@";
import { searchValuesPayload } from "./helpers";

// Function to get Scheduled Message with filters and pagination
export const getScheduledMessage = (page = 1, pageSize = "", search) => {
  const messageId = location.pathname.split("/").pop();
  return api.post(
    `/api/AdminScheduledMessages/${messageId}/users`,
    searchValuesPayload(page, pageSize, search),
  );
};
